import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { PackageNameDisplay } from './PackageNameDisplay';
import { FeatureList } from '../FeatureList';
import { breakpoints, colors } from '../../constants';
import { IFeature, IGlassesPackage } from '../../types';

const ReadingArea = styled.div``;
const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 60px;

    @media (${breakpoints.mediumMin}) {
        padding-right: 40px;
        padding-bottom: 0;
        margin-top: 0;
        flex-direction: row;
    }
`;

interface IProps {
    features: IFeature[];
    selectedPackage: IGlassesPackage;
    className?: string;
}

const BaseGlassesPackageDisplay = ({
    features,
    selectedPackage,
    className,
}: IProps) => {
    const { t } = useTranslation();
    const showReadingArea = selectedPackage.readingArea > 0;

    interface IReadingAreaData {
        [key: string]: string;
    }

    // Reading area can have a value from 1-4 (or no value)
    const readingAreaTitle: IReadingAreaData = {
        1: 'readingArea.normal',
        2: 'readingArea.wide',
        3: 'readingArea.extraWide',
        4: 'readingArea.veryWide',
    };

    const imageSrc: IReadingAreaData = {
        1: 'https://grandvision.s3.amazonaws.com/pbe/images/leesgebied_normaal.png',
        2: 'https://grandvision.s3.amazonaws.com/pbe/images/leesgebied_breed.png',
        3: 'https://grandvision.s3.amazonaws.com/pbe/images/leesgebied_extra_breed.png',
        4: 'https://grandvision.s3.amazonaws.com/pbe/images/leesgebied_zeer_breed.png',
    };

    return (
        <div className={className}>
            <HeaderRow>
                <PackageNameDisplay starAmount={selectedPackage.strength} />
            </HeaderRow>
            <FeatureList features={features} glassesPackage={selectedPackage} />
            {showReadingArea && (
                <ReadingArea>
                    <h3>
                        {t(
                            readingAreaTitle[
                                selectedPackage.readingArea.toString()
                            ]
                        )}
                    </h3>
                    <img
                        alt="Breedte leesgebied"
                        src={imageSrc[selectedPackage.readingArea.toString()]}
                    />
                </ReadingArea>
            )}
        </div>
    );
};

export const GlassesPackageDisplay = styled(BaseGlassesPackageDisplay)`
    @media (${breakpoints.mediumMin}) {
        flex: 0 0 45%;

        ${HeaderRow} {
            margin-top: 5px;
        }
    }

    ${ReadingArea} {
        margin-top: 20px;
    }

    h3 {
        color: ${colors.greenDark};
    }

    img {
        width: auto;
        max-width: 120px;
    }
`;
